// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"cda889c7","453":"eaf7c884"}[chunkId] + ".chunk.js";
};